<div class="workday-projects-panel">

  <div class="actions">
    <button (click)="addWorkdayLink()">Link Workday Project(s)</button>
    <a href="https://tnc.box.com/s/tidomhe9q5et2hhrr26979de0pcvubrp" target="_blank">Financials FAQ and Guidance</a>
  </div>

  <div class="workday-projects">

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Current Workday Projects</mat-panel-title>
      </mat-expansion-panel-header>

      @if(activeProjectFinanceProjects?.length) {
        <div class="results-grid">

          <div class="results-header">
            <div></div>
            <div></div>
            <div>WD Project ID</div>
            <div>WD Status</div>
            <div>WD Project Name</div>
            <!-- <div>Business Unit</div> -->
            <div>Link Created By</div>
            <!-- <div>Link Created On</div> -->
          </div>

          @for (pfp of activeProjectFinanceProjects; track pfp) {
            <div class="result-row">
              <div>
                <a class="action-link" href="javascript:void(0)" (click)="deleteWorkdayLink(pfp)"
                  matTooltip="Unlink Workday Project" matTooltipShowDelay="500" matTooltipHideDelay="300">
                  <img src="assets/images/icons/unlink_icon.png">
                  <div class="action-label">UNLINK</div>
                </a>
              </div>
              <div>
                <a class="action-link" href="javascript:void(0)" (click)="archiveFinanceProjectLink(pfp)"
                  matTooltip="Archive Workday Project" matTooltipShowDelay="500" matTooltipHideDelay="300">
                  <i class="icon-drawer2"></i>
                  <div class="action-label">ARCHIVE</div>
                </a>
              </div>
              <div>
                {{pfp.financeProject.workdayCode}}
              </div>
              <div>
                {{pfp.financeProject.status}}
              </div>
              <div>
                {{pfp.financeProject.name}}
              </div>
              <!-- <div>
              {{pfp.financeProject.businessUnitName ? pfp.financeProject.businessUnitName : '(No BU in Workday)'}}
            </div> -->
            <div class="creator-info">
              <div class="created-by">
                {{pfp.createdByUser.fullName}}
              </div>
              <div class="created-on">
                {{pfp.createdOn | date:'dd-MMM-yyyy'}}
              </div>
            </div>
          </div>
        }
      </div>
    }
    @else {
    <div class="alert alert-info alert-styled-left shadow-0 ng-star-inserted">
      There are no active links to Workday projects.
    </div>
  }



</mat-expansion-panel>

<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>Archived Workday Projects</mat-panel-title>
  </mat-expansion-panel-header>

  @if (archivedProjectFinanceProjects?.length) {
    <div class="results-grid">

      <div class="results-header">
        <div></div>
        <div></div>
        <div>WD Project ID</div>
        <div>WD Status</div>
        <div>WD Project Name</div>
        <!-- <div>Business Unit</div> -->
        <div>Link Created By</div>
        <!-- <div>Link Created On</div> -->
      </div>

      @for (pfp of archivedProjectFinanceProjects; track pfp) {
        <div class="result-row">
          <div>
            <a class="action-link" href="javascript:void(0)" (click)="deleteWorkdayLink(pfp)"
              matTooltip="Unlink Workday Project" matTooltipShowDelay="500" matTooltipHideDelay="300">
              <img src="assets/images/icons/unlink_icon.png">
              <div class="action-label">UNLINK</div>
            </a>
          </div>
          <div>
            <a class="action-link" href="javascript:void(0)" (click)="activateFinanceProjectLink(pfp)"
              matTooltip="Activate Workday Project" matTooltipShowDelay="500" matTooltipHideDelay="300">
              <i class="majesticons--textbox-plus-line"></i>
              <div class="action-label">ACTIVATE</div>
            </a>
          </div>
          <div>
            {{pfp.financeProject.workdayCode}}
          </div>
          <div>
            {{pfp.financeProject.status}}
          </div>
          <div>
            {{pfp.financeProject.name}}
          </div>
          <!-- <div>
          {{pfp.financeProject.businessUnitName ? pfp.financeProject.businessUnitName : '(No BU in Workday)'}}
        </div> -->
        <div class="creator-info">
          <div class="created-by">
            {{pfp.createdByUser.fullName}}
          </div>
          <div class="created-on">
            {{pfp.createdOn | date:'dd-MMM-yyyy'}}
          </div>
        </div>
      </div>
    }
  </div>
}
@else {
<div class="alert alert-info alert-styled-left shadow-0 ng-star-inserted">
  There are no archived links to Workday projects.
</div>
}


</mat-expansion-panel>

</div>

</div>
